import { Accordion, Card } from "#/atoms";
import { FC, memo, useCallback, useState } from "react";

import { DESKTOP_SPACING } from "@/theme";
import { HeadingIcon } from "#/molecules";
import { ORDER_STATE } from "@/types";
import OrderServiceHeader from "./OrderServiceHeader";
import { PhotoProps } from "./OrderService.interface";
import PhotoUploader from "./PhotoUploader";
import VirtualStagingFurnitureFields from "../VirtualStagingFurniture/VirtualStagingFurnitureFields";
import { useNavigate } from "react-router-dom";

const VirtualStaging: FC<PhotoProps> = ({
  amount,
  draftFiles,
  externalUrl,
  isAdmin,
  isOffered = false,
  name,
  notificationMessage,
  notifications,
  onAskToChangeWorker,
  onConfirmFiles,
  onChangeUrl,
  onChooseDraftFiles,
  onDeleteFiles,
  onDownloadFiles,
  onNotifyCustomer,
  onUploadFiles,
  orderPrice,
  orderState,
  outtakesMode,
  selectedWorkerName,
  serviceId,
  type,
  uploadedFiles,
}) => {
  const navigate = useNavigate();

  const [selectedPhotoFiles, setSelectedPhotoFiles] = useState<string[]>([]);

  const accordionState = 'open';

  const handleChangeWorker = useCallback(() => {
    onAskToChangeWorker?.(serviceId);
  }, [serviceId])

  const handleConfirmFiles = async (serviceIdInput: string, files: string[], isDraft : boolean) => {
    await onConfirmFiles?.(serviceIdInput, files, isDraft);
  }

  const handleDeleteFiles = async (serviceIdInput: string, files: string[], isDraft : boolean) => {
    await onDeleteFiles?.(serviceIdInput, files, isOffered, isDraft);
  }

  const handleDownloadFiles = (serviceIdInput: string, files: string[], isDraft : boolean, ) => {
    const resolutions : string[] = [];

    onDownloadFiles(serviceIdInput, selectedPhotoFiles, isDraft, resolutions);
  };

  const handleUploadFiles = async (serviceIdInput: string, files: File[], isDraft : boolean) => {
   await onUploadFiles?.(serviceId, files, isDraft);
  }

  const selectedFiles = uploadedFiles.filter(f => f.fileStatus === 1);

  return (
    <Card>
        <Accordion
          header={<HeadingIcon icon="services" mb={`${DESKTOP_SPACING.XXL}px`} title={`${name} ${amount ? " X" + amount : ""}`} />}
          showArrow
          state={accordionState}
        >
         { isAdmin &&  <OrderServiceHeader
                name={name}
                notificationMessage={notificationMessage}
                notifications={notifications}
                onAskToChangeWorker={handleChangeWorker}
                onNotifyCustomer={onNotifyCustomer}
                selectedWorkerName={selectedWorkerName}
                serviceId={serviceId}
                type={type} /> }

          <VirtualStagingFurnitureFields
            externalUrl={externalUrl}
            isAdmin={isAdmin}
            orderServiceId={serviceId}
            onChangeUrl={onChangeUrl}
          />

          {!outtakesMode && <PhotoUploader
            amount={amount}
            files={ orderState === ORDER_STATE.CONTENT_SELECTED ? selectedFiles : uploadedFiles}
            isAdmin = {isAdmin}
            isDraft = {false}
            notifications={notifications}
            onConfirmFiles={handleConfirmFiles}
            onDeleteFiles={handleDeleteFiles}
            onDownloadFiles={handleDownloadFiles}
            onSetSelectedFiles={setSelectedPhotoFiles}
            onUploadFiles={handleUploadFiles}
            orderPrice={orderPrice}
            orderState={orderState}
            serviceId={serviceId} /> }

          <PhotoUploader
            files={draftFiles || []}
            isAdmin = {isAdmin}
            isDraft = {true}
            title="Outtakes"
            notifications={notifications}
            onChooseDraftFiles={onChooseDraftFiles}
            onDeleteFiles={handleDeleteFiles}
            onDownloadFiles={handleDownloadFiles}
            onUploadFiles={handleUploadFiles}
            orderState={orderState}
            outtakesMode={outtakesMode}
            serviceId={serviceId}
            />

      </Accordion>
     </Card>
  );
};

export default memo(VirtualStaging);